export default {"src":"/_next/static/media/clearIcon.0b81b224.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};